"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_components_1 = require("@zapier/common-components");
const theme_1 = require("@zapier/theme");
const core_1 = require("@emotion/core");
const getRootCss = (color) => core_1.css({
    button: {
        padding: theme_1.Spacing.small,
        minHeight: 'auto',
        color,
    },
});
const EditorGuideIconButton = (props) => {
    const { color, isDisabled, label, name, onClick } = props;
    return (core_1.jsx("div", { css: getRootCss(color) },
        core_1.jsx(common_components_1.Button, { backgroundType: "clear", isDisabled: isDisabled || !onClick, label: label, onClick: onClick },
            core_1.jsx(common_components_1.Icon, { name: name, size: 12 }))));
};
EditorGuideIconButton.defaultProps = {
    isDisabled: false,
    color: theme_1.Colors.steel,
};
exports.default = EditorGuideIconButton;
